import { HeartBank } from "../../../managers/HeartBank.ts";
import { Crypto } from "../../Crypto.ts";
import template from "./hb-hold.mjs";
import { render } from "lit-html";
import { fs } from "../../../firebase.ts";
import {
    collection,
    getDocs,
    query,
    orderBy,
    updateDoc
} from "firebase/firestore";
import { wait } from "../../global.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

export class HbHold extends HTMLElement {
    private heartbank = new HeartBank();
    private crypto: Crypto = new Crypto();
    private modal: ModalInterface;

    private hold: HTMLElement;
    private bankkeys: HTMLUListElement;
    private add: HTMLButtonElement;
    private message: HTMLParagraphElement;

    private bankkeysCount = 0;

    constructor() {
        super();
        render(template(null), this);

        this.hold = this.querySelector("#hb-hold")!;
        this.bankkeys = this.querySelector("#hb-hold-bankkeys")!;
        this.add = this.querySelector("#hb-hold-add")!;
        this.message = this.querySelector("#hb-hold-message")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        const instanceOptions: InstanceOptions = {
            id: "hb-hold",
            override: true
        };

        this.modal = new Modal(this.hold, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.add.addEventListener("click", this.addBankkey.bind(this));

        this.heartbank.addAuthStateListener((user) => {
            if (this.heartbank.isAdmin()) this.render();
        });
    }

    private async addBankkey() {
        this.add.disabled = true;
        this.message.textContent = "Creating Bankkey...";
        this.message.style.color = "orange";
        const name = prompt("Please enter a name for this Bankkey:");
        if (name) {
            const status = await this.crypto.add(name);
            this.message.textContent = "Success!"; //status.text = bid
            this.message.style.color = status.color;
            if (this.bankkeysCount === 0) await wait(1); //if not good then refactor to onSnapshot
            this.render();
        } else {
            this.message.textContent = "";
        }
        this.add.disabled = false;
    }

    private async render() {
        const keysQuery = query(collection(fs, "bankkeys"), orderBy("name"));
        const keysSnap = await getDocs(keysQuery);
        this.bankkeysCount = keysSnap.size;

        if (keysSnap.empty) {
            this.bankkeys.innerHTML = "There are currently no Bankkeys";
            this.bankkeys.style.color = "gray";
        } else {
            this.bankkeys.innerHTML = "";
            this.bankkeys.style.color = "";

            keysSnap.docs.forEach((doc, index) => {
                const { name } = doc.data();
                const li = document.createElement("li");
                li.classList.add(
                    "flex",
                    "items-center",
                    "justify-between",
                    index === this.bankkeysCount - 1 ? "mb-0" : "mb-4",
                    "bg-white",
                    "dark:bg-gray-800",
                    "border",
                    "border-gray-200",
                    "dark:border-gray-700",
                    "shadow-sm",
                    "rounded-lg",
                    "p-4",
                    "text-lg",
                    "font-semibold",
                    "text-gray-900",
                    "dark:text-white"
                );

                const span = document.createElement("span");
                span.innerHTML = "🗝️&nbsp;&nbsp;" + name;
                span.classList.add("cursor-pointer");
                span.onclick = async () => {
                    const newName = prompt(
                        "New name for your Bankkey:",
                        name
                    )?.trim();
                    if (newName && newName !== name) {
                        await updateDoc(doc.ref, { name: newName });
                        this.message.textContent = `${name} has been renamed to ${newName}`;
                        this.message.style.color = "green";
                        this.render();
                    }
                };

                const publicBtn = document.createElement("button");
                publicBtn.classList.add("cursor-pointer");
                publicBtn.textContent = "📋"; //Public Bankkey
                publicBtn.onclick = async () => {
                    await navigator.clipboard.writeText(doc.id);
                    this.message.textContent =
                        name +
                        "'s Public Bankkey has been copied to your clipboard!";
                    this.message.style.color = "green";
                };

                li.append(span, publicBtn);
                this.bankkeys.appendChild(li);
            });
        }
    }

    show() {
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }
}
